import React from 'react';
import PopOver from 'rawr/controls/PopOver';
import Contact from 'rawr/controls/Contact';
import cn from 'classnames';
import './TopBar.scss';

// Imported here, but referenced in base.html for all apps
import 'favicon.ico';

export default React.createClass({
    propTypes: {
        home: React.PropTypes.object,
        app: React.PropTypes.object,
        loading: React.PropTypes.bool,
    },
    getDefaultProps() {
        return {
            home: {label: 'Home', href: '/n/', icon: 'A'}
        };
    },
    render() {
        const {home, app, loading} = this.props;
        const logged_in = current_user && !current_user.anonymous;
        const tools = [
            {"title": "Component Reference", "path": "/n/components"},
            {"title": "Groups App", "path": "/n/groups"}
        ];

        if (typeof(flag) === 'function' && flag('topbar_anchor_tool')) {
            tools.push({"title": "Anchor Tool", "path": "/n/ftcontent/#/anchor/list"});
        }


        return (
            <div className="top_bar_wrapper">
                <header className="top_bar">
                    <div className="top_bar_nav top_bar_nav_left">
                        <a className="link_home left" href={home.href}>
                            <span className={cn('portal_button', {breathing : loading})}>{home.icon}</span>
                            <span className="btn_text btn_text_hidden">{home.label}</span>
                        </a>
                        {app ? (
                            <a className="link_app btn btn--color_blue btn--size_medium icon" data-icon-before={app.icon} href={app.href}>
                                <span className="btn_text">{app.label}</span>
                            </a>
                            ) : null}
                            {current_user.is_staff ? (
                                <PopOver width="medium" label="Tools">
                                    <ul className="menu user_menu">
                                        {tools.map(function(tool, index){
                                            return <li key={index}><a href={tool.path}>{tool.title}</a></li>
                                            })}
                                        </ul>
                                    </PopOver>
                                    ) : null}
                                </div>

                                <div className="top_bar_nav top_bar_nav_right">
                                    <PopOver width="auto" label={<span className="btn_text btn_text_hidden">Help</span>} buttonIconBefore="?">
                                        <Contact user={current_user} className="user_help_req" />
                                    </PopOver>

                                    {logged_in ? (
                                        <PopOver width="auto" label={<span className="btn_text btn_text_hidden">{current_user.first_name}</span>} buttonIconBefore="u">
                                            <ul className="menu user_menu">
                                                <li><a href={config.url.account} className="icon before arrow" data-icon="*">My Account</a></li>
                                                <li><a href={config.url.logout} className="icon before arrow" data-icon="X">Logout</a></li>
                                            </ul>
                                        </PopOver>
                                        ) : null}
                                    </div>
                                </header>
                                <div className="top_bar_spacer"></div>
                            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/controls/TopBar.jsx
 **/